import { QueryConfig } from "store/utils/query-config";

export const selfServicePortalsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["metaData.createdAt"]
  }
};
